import React from "react";
import icon1 from "../../../assets/images/whiky_house/icon 1.png";
import icon2 from "../../../assets/images/whiky_house/icon 2.png";
import icon3 from "../../../assets/images/whiky_house/icon 3.png";
import icon4 from "../../../assets/images/whiky_house/icon 4.png";
const Cards = () => {
  const data = [
    {
      id: 1,
      icons: icon3,
      title: "Free Delivery",
      text: "Same day delivery for orders before 6pm",
    },
    {
      id: 2,
      icons: icon4,
      title: "Loyalty Cards",
      text: "Earn points and redeem",
    },
    {
      id: 3,
      icons: icon2,
      title: "Visit Our Store",
      text: "Come for a tasting before buying our bottles",
    },
    {
      id: 4,
      icons: icon1,
      title: "100% Authentic",
      text: "We guarantee the authenticity of all our products",
    },
  ];
  return (
    <div className="grid gap-5 lg:gap-0 lg:grid-cols-4 grid-cols-2 my-20 px-10">
      {data.map((item) => (
        <div key={item.id} className="flex flex-col items-center gap-3">
          <div className="text-[#DEC092]  text-[14px] md:text-[18px] font-bold">
            <img src={item.icons} className="w-32" alt="" />
          </div>
          <div className="text-center ">
            <h1 className="text-[16px] md:text-[21px] font-bold mb-1">
              {item.title}
            </h1>
            <p className=" text-[14px] md:text-[18px] md:px-10 lg:px-4">
            {item.text}
            </p>
          </div>
        </div>
      ))}
    
    </div>
  );
};

export default Cards;
